import { showToast } from "vant";
import { useI18n } from "vue-i18n";

/** 国家 Tab：当前区域数据加载中时不允许切换，并提示用户 */
export function useMapTilerCountryTabSwitch({
  switchCountryBase,
  listLoading,
  mapRegion,
}) {
  const { t } = useI18n();

  const isRegionTabSwitchDisabled = (region) =>
    listLoading.value && mapRegion.value !== region;

  const switchCountry = async (region) => {
    if (mapRegion.value === region) return;
    if (listLoading.value) {
      showToast(t("app.home.map_region_switch_loading"));
      return;
    }
    await switchCountryBase(region);
  };

  return { switchCountry, isRegionTabSwitchDisabled };
}
